import { SuiteManifest } from '../manifest';
import { marketingRoutes } from './routes';
import { marketingNavItems } from './nav';

export const marketingManifest: SuiteManifest = {
  id: 'marketing',
  name: 'Marketing & Success',
  basePath: '/marketing',
  icon: 'zap',
  description: 'Marketing & Success suite modules and operations.',
  requiredPermission: 'marketing.read',
  nav: marketingNavItems,
  routes: marketingRoutes,
};

export default marketingManifest;
